/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    fwaLayer: any;
  }
}

export interface ApplicationEvent {
  eventType: 'application';
  application: {
    type: 'click';
    elements: string[];
  };
}

const applicationEvent: ApplicationEvent = {
  eventType: 'application',
  application: {
    type: 'click',
    elements: [],
  },
};

export interface ClickEvent {
  eventType: 'click';
  click: ClickElement;
}

export interface ClickElement {
  category: string;
  subCategory: string;
  name: string;
  detail: string;
}

const fwaLayer = window.fwaLayer;
const separator = '/';
const fallbackSeparator = '-';

function escapingSeparator(item: string): string {
  return item.replace(separator, fallbackSeparator);
}

export function econdaClickEvent(stepName: string, stepArea: string, element: string, value: string) {
  if (fwaLayer) {
    const dataType = 'applications';
    const applicationName = fwaLayer.page.globalContentId;
    const applicationStep = 1;
    const applicationEvent: ApplicationEvent = {
      eventType: 'application',
      application: {
        type: 'click',
        elements: [],
      },
    };
    const econdaString = `${dataType}${separator}${applicationName}${separator}${applicationStep}${separator}${stepName}${separator}${stepArea}${separator}${escapingSeparator(
      element,
    )}${separator}${escapingSeparator(value)}`.toLowerCase();

    applicationEvent.application.elements.push(econdaString);
    fwaLayer.sendChunks(applicationEvent);
  }
}

const escapeString = (item: string): string => {
  return item.replace(/[/_]/g, '-');
};

export function econdaDownloadEvent(category: string, subCategory: string, name: string, detail: string): void {
  if (fwaLayer) {
    const dataType = 'applications';
    const applicationName = fwaLayer.page.globalContentId;
    const applicationStep = 1;
    const clickEvent: ClickEvent = {
      eventType: 'click',
      click: {
        category,
        subCategory,
        name,
        detail,
      },
    };
    const econdaString = `${dataType}${separator}${applicationName}${separator}${applicationStep}${separator}${category}${separator}${subCategory}${separator}${escapingSeparator(
      name,
    )}${separator}${escapingSeparator(detail)}`.toLowerCase();

    applicationEvent.application.elements.push(escapeString(econdaString));
    fwaLayer.send(clickEvent);
  }
}
